export default __webpack_public_path__ + "static/media/037-house.b8554e2c.png";